import { useMemo } from "react"
import { useFormContext } from "react-hook-form"

import { groupBy } from "shared/lib/arrayUtils"
import { useEvent } from "shared/lib/useEvent"
import { FilePreview } from "shared/types/File"

import { AttachmentLinkFormProps } from "../AttachmentLinkForm"
import { AttachmentLinkFormViewModel } from "../types/AttachmentLinkFormViewModel"

export function useAttachmentLinkFormViewModel({
  attachments,
  linkedAttachments,
  categories,
  getName,
  onUpload,
  isReadonly
}: AttachmentLinkFormProps): AttachmentLinkFormViewModel {
  const derivedAttachments = isReadonly ? linkedAttachments : attachments
  const { setValue, resetField } = useFormContext()

  const attachmentsByCategory = useMemo(() => {
    return groupBy(derivedAttachments ?? [], file => file.category || "unknown")
  }, [derivedAttachments])

  const handleUpload = useEvent((file: FilePreview, category: string) => {
    const promise = onUpload?.(file, category)

    if (promise) {
      promise.then(response => {
        if (response.data) {
          // set default of field to true and reset
          // then set dirty field
          setValue(getName(response.data), true)
          resetField(getName(response.data))
          setValue(getName(response.data), true, { shouldDirty: true })
        }
      })
    }

    return promise
  })

  return {
    attachmentsByCategory,
    categories,
    getName,
    onUpload: onUpload ? handleUpload : undefined,
    isReadonly
  }
}
